<template>
  <div>
    <BusinessViewHeader
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :is_on_details_view="false"
    ></BusinessViewHeader>
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Edit Contacts Info Form"
      id="owner_view_contacts_edit_form"
    ></CardedSectionHeader>
    <CardedForm
      ref="edit_contacts_form_ref"
      id="edit_contacts_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <v-row>
        <v-col>
          <TextField
            v-model="form.office_phone_number1"
            :validation_rules="form_validations.office_phone_number1"
            label="Officee Phone Number"
            icon="mdi-phone-classic"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col>
          <TextField
            v-model="form.mobile_phone_number1"
            :validation_rules="form_validations.mobile_phone_number1"
            label="Mobile Phone Number"
            icon="mdi-cellphone-basic"
            :disabled="is_loading"
          ></TextField>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <TextField
            v-model="form.fax_number"
            :validation_rules="form_validations.fax_number"
            label="Fax Number"
            icon="mdi-fax"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col>
          <TextField
            v-model="form.pobox_number"
            :validation_rules="form_validations.pobox_number"
            label="P.O.Box"
            icon="mdi-send"
            :disabled="is_loading"
          ></TextField>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <TextField
            v-model="form.email_address_1"
            :validation_rules="form_validations.email_address_1"
            label="Email Address"
            icon="mdi-email-variant"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col>
          <TextField
            v-model="form.website_1"
            :validation_rules="form_validations.website_1"
            label="Website"
            icon="mdi-earth"
            :disabled="is_loading"
          ></TextField>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col>
          <TextField
            v-model="form.whatsapp_link"
            :validation_rules="form_validations.whatsapp_link"
            label="Whatsapp Number"
            icon="mdi-whatsapp"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col>
          <TextField
            v-model="form.facebook_link"
            :validation_rules="form_validations.facebook_link"
            label="Facebook Link"
            icon="mdi-facebook"
            :disabled="is_loading"
          ></TextField>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <TextField
            v-model="form.twitter_link"
            :validation_rules="form_validations.twitter_link"
            label="Twitter Link"
            icon="mdi-twitter"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col>
          <TextField
            v-model="form.instagram_link"
            :validation_rules="form_validations.instagram_link"
            label="Instagram Link"
            icon="mdi-instagram"
            :disabled="is_loading"
          ></TextField>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <TextField
            v-model="form.youtube_link"
            :validation_rules="form_validations.youtube_link"
            label="Youtube Link"
            icon="mdi-youtube"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col>
          <TextField
            v-model="form.linked_link"
            :validation_rules="form_validations.linked_link"
            label="Linked Link"
            icon="mdi-linkedin"
            :disabled="is_loading"
          ></TextField>
        </v-col>
      </v-row>
    </CardedForm>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import BusinessViewHeader from "./../../../components/BusinessViewHeader";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedForm from "../../../components/CardedForm";
import TextField from "../../../components/TextField";
export default {
  name: "OwnerBusinessesManageContacts",
  components: {
    BusinessViewHeader,
    CardedSectionHeader,
    CardedForm,
    TextField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      business_id: 0,
      business: Utils.get_default_business(),
      is_owner: false,
      _user: null,
      errors: [],
      message: "",
      form: {
        office_phone_number1: "",
        mobile_phone_number1: "",
        email_address_1: "",
        website_1: "",
        fax_number: "",
        pobox_number: "",
        facebook_link: "",
        twitter_link: "",
        instagram_link: "",
        youtube_link: "",
        linked_link: "",
        whatsapp_link: "",
      },
      form_validations: {
        office_phone_number1: [
          Utils.validate.if_provided_phone_number(
            "Please enter a valid officee phone number",
            true
          ),
        ],
        mobile_phone_number1: [
          Utils.validate.if_provided_phone_number(
            "Please enter a valid phone number"
          ),
        ],
        email_address_1: [
          Utils.validate.if_provided_email_format(
            "Please enter a email number"
          ),
        ],
        website_1: [
          Utils.validate.max_length(
            200,
            "Website must not be more than 200 characters"
          ),
        ],
        fax_number: [
          Utils.validate.max_length(
            15,
            "Fax number cannot be more than 15 characters"
          ),
        ],
        pobox_number: [
          Utils.validate.max_length(
            150,
            "Your pobox should not be more than 150 characters"
          ),
        ],
        facebook_link: [
          Utils.validate.max_length(
            200,
            "Facbook link must not be more than 200 characters"
          ),
        ],
        twitter_link: [
          Utils.validate.max_length(
            200,
            "Twitter link must not be more than 200 characters"
          ),
        ],
        instagram_link: [
          Utils.validate.max_length(
            200,
            "Instagram link must not be more than 200 characters"
          ),
        ],
        youtube_link: [
          Utils.validate.max_length(
            200,
            "Youtube link must not be more than 200 characters"
          ),
        ],
        linked_link: [
          Utils.validate.max_length(
            200,
            "LinkedIn link must not be more than 200 characters"
          ),
        ],
        whatsapp_link: [
          Utils.validate.if_provided_phone_number(
            "Please enter a valid whatsapp phone number"
          ),
        ],
      }
    };
  },
  methods: {
    on_auto_fill() {
      this.init_form();
    },
    init_form() {
      this.form.office_phone_number1 = this.business.office_phone_number1;
      this.form.mobile_phone_number1 = this.business.mobile_phone_number1;
      this.form.email_address_1 = this.business.email_address_1;
      this.form.website_1 = this.business.website_1;
      this.form.fax_number = this.business.fax_number;
      this.form.pobox_number = this.business.pobox_number;
      this.form.facebook_link = this.business.facebook_link;
      this.form.twitter_link = this.business.twitter_link;
      this.form.instagram_link = this.business.instagram_link;
      this.form.youtube_link = this.business.youtube_link;
      this.form.linked_link = this.business.linked_link;
      this.form.whatsapp_link = this.business.whatsapp_link;
      this.errors = [];
      this.message = "";
    },
    load_business(id) {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_business(
        {
          id: id,
          user_id: this._user.id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          if (res) {
            this.business = res;
            if (
              this._user &&
              this._user != null &&
              parseInt(this._user.id) == parseInt(this.business.user_id)
            ) {
              this.is_owner = true;
            }
            this.init_form();
            //nyd
            //if they are not the owner
            //show them a message of not authorised
            //then redirect them to the login screen
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.$refs.edit_contacts_form_ref.show_error_dialog();
        }
      );
    },
    submit() {
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Businesses.update_business_contacts(
        {
          ...this.form,
          id: this.business_id
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.message =
            "<b>Operation was successfull</b> <br/> Your business contact information has been updated successfully";
          this.$refs.edit_contacts_form_ref.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.edit_contacts_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
    on_hide_message() {
      this.load_business(this.business_id);
    }
  },
  computed: {
    
  },
  mounted() {
    //   console.log(this.$route.params);
    this.business_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if the _user is not there  then just take this dude
    //to the loggin screen

    this.$emit("set-page-attributes", {
      title: "Business Manage Contacts Info",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/owner/businesses/",
        },
        {
          text: "List",
          disabled: false,
          href: "/owner/businesses/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/owner/businesses/list/view/" + this.business_id,
        },
        {
          text: "Contacts",
          disabled: true,
          href:
            "/owner/businesses/list/view/" +
            this.business_id +
            "/contacts/manage",
        },
      ],
      navbar_cols: 3,
    });
    this.load_business(this.business_id);

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_view_contacts_edit_form", options);
  },
};
</script>